import skillsActionConstants from '../constants/skillsActionConstants';

const initialState = {
  skills: [],
};

const skillsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case skillsActionConstants.GET_SKILLS:
      return {
        ...state,
        skills: action.payload.skills,
      };
    default:
      return state;
  }
};

export default skillsReducer;
